import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65a41512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","padding":"24px","justify-content":"start"} }
const _hoisted_2 = { style: {"display":"flex","padding":"24px","justify-content":"start"} }
const _hoisted_3 = { style: {"display":"flex","padding":"24px","justify-content":"start"} }
const _hoisted_4 = { style: {"display":"flex","flex":"1","padding":"24px","justify-content":"start"} }
const _hoisted_5 = { style: {"flex":"1","padding":"24px","justify-content":"start"} }
const _hoisted_6 = {
  key: 5,
  id: "save-banner"
}

import CodeEditor from '@/components/CodeEditor.vue'
import DataPointEditor from '@/components/DataPointEditor.vue'
import ProfileMetaForm from '@/components/ProfileMetaForm.vue'
import ProfileLoRaWANForm from '@/components/ProfileLoRaWANForm.vue'
import CodecValidator from '@/components/CodecValidator.vue'
import CreateMethod from './CreateMethod.vue'
import { computed, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { NewProfileStore } from '@/store/newProfileStore'
import { useRoute, useRouter } from 'vue-router'
import { ProfilesStore } from '@/store/profiles'

interface CreateProfleStepMap {
  STEP_TYPE: 0
  STEP_META: 1,
  STEP_DP: 2,
  STEP_VERIFY: 3,
  STEP_DONE: 4,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewProfile',
  setup(__props) {


const router = useRouter()

const CreateProfleStep:CreateProfleStepMap = {
  STEP_TYPE: 0,
  STEP_META: 1,
  STEP_DP: 2,
  STEP_VERIFY: 3,
  STEP_DONE: 4
}

const route = useRoute()
const editId = route.query.id ? route.query.id as string : undefined
const step = ref<CreateProfleStepMap[keyof CreateProfleStepMap]>(CreateProfleStep.STEP_TYPE)
const newProfileStore = new NewProfileStore()
const profileOverview = computed(() => newProfileStore.GetProfile())
const lorawanRef = ref()
const metaRef = ref()
const DataPointEditorRef = ref()
const CodeCEditorRef = ref()
const CodeValidatorRef = ref()
const profileStore = new ProfilesStore()
let isEdit = false
const NextStep = async () => {
  switch (step.value) {
    case CreateProfleStep.STEP_META: {
      try {
        await metaRef.value.Submit()
        await lorawanRef.value.Submit()
        step.value += 1
      } catch (err: any) {
        ElMessage.error(err.message)
      }
      break
    }
    case CreateProfleStep.STEP_DP: {
      try {
        await CodeCEditorRef.value.Submit()
        step.value += 1
      } catch (err: any) {
        ElMessage.error(err.message)
      }
      break
    }
    case CreateProfleStep.STEP_VERIFY: {
      try {
        await CodeValidatorRef.value.Submit()
        const data = newProfileStore.GetProfile()
        if (isEdit) {
          loading.value = true
          profileStore.Update(editId!, data).then(() => {
            ElMessage.success('Update Successful')
            step.value += 1
          }).catch((err:unknown) => {
            ElMessage.error('Unable to update profile' + err.message)
          }).finally(() => {
            loading.value = false
          })
        } else {
          loading.value = true
          profileStore.Create(data).then(() => {
            ElMessage.success('Create Successful')
            step.value += 1
          }).catch(err => {
            ElMessage.error(err.message)
          }).finally(() => {
            loading.value = false
          })
        }
      } catch (err: any) {
        ElMessage.error(err.message)
      }

      break
    }
    default: step.value += 1; break
  }
}

const PrevStep = () => {
  if (step.value > CreateProfleStep.STEP_META) { step.value -= 1 }
}

const OnClose = () => {
  router.back()
}

const OnReview = () => {
  const id = newProfileStore.GetProfile().id
  router.push({ name: 'profile-overview', query: { id: id } })
}

const loading = ref(false)

onMounted(async() => {
  if (route.query.id !== undefined) {
    isEdit = true
    step.value = 1
    try {
      loading.value = true
      const data = await profileStore.Fetch(route.query.id as string)
      await newProfileStore.Upload(data)
      metaRef.value.Load()
      lorawanRef.value.Load()
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
})


return (_ctx: any,_cache: any) => {
  const _component_ElCol = _resolveComponent("ElCol")!
  const _component_ElRow = _resolveComponent("ElRow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_result = _resolveComponent("el-result")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_ElRow, null, {
    default: _withCtx(() => [
      _createVNode(_component_ElCol, { span: 24 }, {
        default: _withCtx(() => [
          (step.value === CreateProfleStep.STEP_TYPE)
            ? (_openBlock(), _createBlock(_component_ElRow, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElCol, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(CreateMethod, {
                        onSelected: _cache[0] || (_cache[0] = ($event: any) => (step.value += 1))
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (step.value === CreateProfleStep.STEP_META)
            ? (_openBlock(), _createBlock(_component_ElRow, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElCol, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(ProfileMetaForm, {
                          ref_key: "metaRef",
                          ref: metaRef
                        }, null, 512)
                      ]),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(ProfileLoRaWANForm, {
                          ref_key: "lorawanRef",
                          ref: lorawanRef
                        }, null, 512)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (step.value === CreateProfleStep.STEP_DP)
            ? (_openBlock(), _createBlock(_component_ElRow, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElCol, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(DataPointEditor, {
                          ref_key: "DataPointEditorRef",
                          ref: DataPointEditorRef
                        }, null, 512)
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(CodeEditor, {
                          ref_key: "CodeCEditorRef",
                          ref: CodeCEditorRef
                        }, null, 512)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (step.value === CreateProfleStep.STEP_VERIFY)
            ? (_openBlock(), _createBlock(_component_ElRow, { key: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElCol, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(CodecValidator, {
                        ref_key: "CodeValidatorRef",
                        ref: CodeValidatorRef
                      }, null, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (step.value === CreateProfleStep.STEP_DONE)
            ? (_openBlock(), _createBlock(_component_ElRow, { key: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElCol, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_result, {
                          icon: "success",
                          title: "Create Profile Successful",
                          "sub-title": "Click 'Review' to open the profile details."
                        }, {
                          extra: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "success",
                              onClick: OnReview
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Review")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: OnClose
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Back")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (step.value !=CreateProfleStep.STEP_TYPE && step.value != CreateProfleStep.STEP_DONE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (step.value != CreateProfleStep.STEP_META)
                  ? (_openBlock(), _createBlock(_component_ElButton, {
                      key: 0,
                      type: "primary",
                      size: "large",
                      onClick: PrevStep
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Prev")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (step.value != CreateProfleStep.STEP_DONE)
                  ? (_openBlock(), _createBlock(_component_ElButton, {
                      key: 1,
                      type: "primary",
                      size: "large",
                      onClick: NextStep
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Next")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_loading, loading.value]
  ])
}
}

})